(() => {
  if (window.__yyCheckoutHandoffLoaded) return;
  window.__yyCheckoutHandoffLoaded = true;

  const CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"]';

  const setSubmitting = (button) => {
    if (!button || button.dataset.yyCheckoutBusy === 'true') return;
    button.dataset.yyCheckoutBusy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy','true');

    const label = button.querySelector('[data-yy-checkout-label], span');
    if (label) {
      button.dataset.yyCheckoutOriginal = label.textContent || '';
      label.textContent = 'Opening secure checkout…';
    } else if (button.value) {
      button.dataset.yyCheckoutOriginal = button.value;
      button.value = 'Opening secure checkout…';
    }
  };

  const resetButton = (button) => {
    if (!button) return;
    button.dataset.yyCheckoutBusy = 'false';
    button.disabled = false;
    button.removeAttribute('aria-busy');

    const original = button.dataset.yyCheckoutOriginal;
    if (!original) return;

    const label = button.querySelector('[data-yy-checkout-label], span');
    if (label) label.textContent = original;
    else if ('value' in button) button.value = original;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const submitter = event.submitter;
    const checkoutButton = submitter?.matches?.(CHECKOUT_SELECTOR)
      ? submitter
      : form.querySelector(CHECKOUT_SELECTOR);

    if (!checkoutButton) return;

    requestAnimationFrame(() => setSubmitting(checkoutButton));
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(resetButton);
  });
})();